export default "/images/vendor/flag-icon-css/flags/1x1/ps.svg?451101efffc43d2b1ae6755db0380c6c";